module.exports = __webpack_public_path__ + "static/media/Niveau_elN14_2_227980.5674d2b9.png";